import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const rejectGrammarClipV1DataSchema = z.object({ rejected: z.literal(true) });

type RejectGrammarClipV1DataType = z.infer<typeof rejectGrammarClipV1DataSchema>;

export type IRejectGrammarClipV1Response = IAPI<RejectGrammarClipV1DataType>;

export const rejectGrammarClipV1ResponseSchema: z.ZodSchema<IRejectGrammarClipV1Response> =
  createApiResponseSchema(
    rejectGrammarClipV1DataSchema,
  ) as z.ZodSchema<IRejectGrammarClipV1Response>;
